export enum ClientsPositions {
  techLead = 'Technical Lead',
  projectManager = 'Project Manager',
  engineeringManager = 'Engineering Manager',
  solutionArchitect = 'Solution Architect',
  productOwner = 'Product Owner',
}
